module.exports = __webpack_public_path__ + "static/img/zengjia2.005bec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/zengjia2.png
// module id = vOQP
// module chunks = 24